<template>
  <ion-card mode="ios" style="margin: 15px 0">
    <ion-card-content>
      <slide-y-up-transition :duration="500">
        <div class="slides-container" v-if="show && showSlider">
          <ion-slides ref="slides"
                      @ionSlideDidChange="slideChanged"
                      :options="slideOpts"
                      mode="md">
            <ion-slide v-for="(item,index) in brands" :key="index">
              <img :src="item.logo"
                   :alt="'Logo ' + item.name"
                   style="display: inline-block; max-width: 120px; margin: 5px 0; pointer-events: none">
            </ion-slide>
          </ion-slides>
          <div class="swiper-button-next swiper-button-gold" @click="nextSlide()"></div>
          <div class="swiper-button-prev swiper-button-gold" @click="prevSlide()"></div>
        </div>
      </slide-y-up-transition>
      <slide-y-up-transition :duration="700" :delay="200">
        <p v-if="show">Od 1 stycznia 2024 r. rozpoczynamy nową edycję Programu Lojalnościowego dedykowanego
          gastronomii! Nasze marki Tyskie, Kozel, Lech, Lech Pils oraz Książęce będą wspierały właścicieli lokali
          gastronomicznych w Polsce. Poniżej znajdziesz zasady i regulamin programu.</p>
      </slide-y-up-transition>
      <hr/>
      <slide-y-up-transition :duration="500" :delay="400">
        <p v-if="show">Aby wziąć udział podpisz umowę z Twoim przedstawicielem handlowym i ciesz się korzyściami.</p>
      </slide-y-up-transition>
      <slide-y-up-transition :duration="500" :delay="600">
        <div v-if="show">
          <ion-button mode="ios"
                      fill="outline"
                      size="small"
                      @click="downloadFile"
                      class="mt-05">Zobacz regulamin marki {{ currentBrandName }}</ion-button>
          <ion-button mode="ios"
                      fill="outline"
                      size="small"
                      @click="openModal"
                      class="mt-05">Czytaj więcej o marce {{ currentBrandName }}</ion-button>
        </div>
      </slide-y-up-transition>
    </ion-card-content>
  </ion-card>
</template>

<script>
  import {mapState} from 'vuex';
  import Modal from '@/components/Modal.vue';

  export default {
    name: 'CardLoyaltyAbout',
    computed: {
      ...mapState({
        loading: state => state.loyalty.loading,
        brands: state => state.loyalty.brands
      }),
      showSlider(){
        return this.brands.length > 0 ? true : false
      },
      currentBrandName: {
        set(name) {
          this.$store.commit('loyalty/LOYALTY_SET_CURRENT_BRAND_NAME', name)
        },
        get() {
          return this.$store.state.loyalty.currentBrandName
        }
      }
    },
    data() {
      return {
        show: false,
        // slider helpers
        sliderIndex: 0,
        sliderLength: 0,
        sliderEnd: false,
        // slider options
        slideOpts: {
          slidesPerView: 1,
        }
      }
    },
    mounted(){
      this.show = true;
      this.$store.commit('loyalty/LOYALTY_SET_CURRENT_BRAND_NAME', 'Tyskie') // reset
    },
    methods: {
      downloadFile(){
        if(!this.brands) return
        let filePath = this.brands ? this.brands[this.sliderIndex].url_to_legal : null
        window.open(filePath, 'download')
      },
      openModal(){
        let title = 'O marce ' + this.currentBrandName
        let catalogue = this.brands ? this.brands[this.sliderIndex].catalogue : null
        let brand_info = this.brands ? this.brands[this.sliderIndex].brand_info : null
        return this.$ionic.modalController.create({
          component: Modal,
          mode: 'ios',
          componentProps: {
            propsData: {
              title: title,
              html: '<img src="'+brand_info+'" style="width: 100%"/>',
              ctaLabel: 'Pobierz katalog',
              route: catalogue,
              routeExternal: true
            },
          },
        }).then(m => m.present())
      },
      slideChanged(){
        // update slider helpers
        this.$refs.slides.getActiveIndex().then(index => {
          this.sliderIndex = index
          // update vuex state
          this.currentBrandName = this.brands[this.sliderIndex].name
        })
        this.$refs.slides.length().then(length => {
          this.sliderLength = length
        })
        this.$refs.slides.isEnd().then(bool => {
          this.sliderEnd = bool
        })
      },
      nextSlide(){
        this.$refs.slides.slideNext()
      },
      prevSlide(){
        this.$refs.slides.slidePrev()
      }
    }
  }
</script>